import { Fragment } from "react";
import { Output } from "valibot";

import { Message, MessageType } from "components/Bubble/Message";
import { IntegrationFormFieldsSchema } from "components/SonicBot/schemas";
import { LocaleSchema } from "shared/schemas";

type Props = {
  formFields: Output<typeof IntegrationFormFieldsSchema>[];
  generationLanguage: Output<typeof LocaleSchema>;
};

function IntegrationFormFields(props: Props) {
  const { formFields, generationLanguage } = props;
  return (
    <div className="mt-2 flex flex-col gap-3">
      {formFields.map((data, idx) => {
        const { label, name, placeholder, required, type, value } = data;
        return (
          <Fragment key={idx}>
            <Message
              generationLanguage={generationLanguage}
              id={name}
              isNonEditable={true}
              type={type as MessageType}
              value={value || ""}
              placeholder={placeholder}
              label={label}
              isRequired={required}
            />
          </Fragment>
        );
      })}
    </div>
  );
}

export default IntegrationFormFields;
